export default "__VITE_ASSET__06f49549__"